import { ResolvedEntity } from '@frontend/common';
import { ForeignEntityMarker, accountIdFromResolvedEntity } from '@frontend/components/common';
import React from 'react';

export interface EntityCardProps {
    title: React.ReactNode;
    entities: ResolvedEntity[] | null;
    subtitle: React.ReactNode;
    icon: React.ComponentType<{ className?: string }>;
}

export const EntityCard = (props: EntityCardProps) => {
    return (
        <div className='bg-background-surface outline-border-default flex flex-col items-start justify-start gap-4 self-stretch rounded-xl p-4 font-medium outline-1 -outline-offset-1'>
            <div className='flex items-center justify-start gap-3'>
                <div className='outline-border-default flex size-11 items-center justify-center rounded-full outline-2 -outline-offset-2'>
                    <props.icon className='size-6' />
                </div>
                <div className='flex flex-col items-start justify-center'>
                    <p className='font-semibold'>{props.title}</p>
                    <p className='text-brand-muted'>{props.subtitle}</p>
                </div>
            </div>
            {props.entities && props.entities.length > 0 && (
                <ul className='flex flex-col gap-2'>
                    {props.entities.map((entity, index) => (
                        <li
                            key={index}
                            className='inline-flex items-center gap-1.5'>
                            {entity.name}
                            <ForeignEntityMarker
                                foreign={entity.foreign}
                                accountId={accountIdFromResolvedEntity(entity)}
                            />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
